import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import useTheme from '@material-ui/core/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Badge from '@material-ui/core/Badge';
import { useHistory } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({

    titleWrapper: {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            marginLeft: theme.spacing(3),
        }
    },
    breadcrumbList: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    breadcrumbs: {
        color: theme.palette.greyTwo.main + '!important',
        '&:hover': {
            cursor: 'pointer',
            textDecoration: 'none',
            color: theme.palette.secondary.main + '!important',
        }
    },
    breadcrumbsLast: {
        whiteSpace: 'nowrap',
        color: theme.palette.greyOne.main + '!important',
    },
    seperator: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    divider: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(6),
        [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        }
    },
    iconSpacing: {
        marginRight: theme.spacing(2),
    },
    iconSizing: {
        fontSize: '3rem',
    },
    buttons: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingTop: theme.spacing(1),
        [theme.breakpoints.down('md')]: {
            justifyContent: 'flex-start',
            marginBottom: theme.spacing(3), 
        }
    },
    badge: {
        minWidth: '24px',
        height: '24px',
        border: '2px solid #FFF',
        borderRadius: '50%'
    },
    badgeOnline: {
        backgroundColor: theme.palette.success.main,
    },
    badgeOffline: {
        backgroundColor: theme.palette.greyFour.main,
    }

}))

/**
 * Fingoti Styled Page Header 
 * @param {Object[]} breadcrumbs - An array of breadcrumbs
 * @param {string} breadcrumbs[].text - Label for the breadcrumb
 * @param {string} breadcrumbs[].link - Route for the breadcrumb when clicked
 */
export const FingotiHeader = ({ breadcrumbs, sectionIcon: SectionIcon, actionButtons, badge }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const classes = useStyles();
    const history = useHistory();

    const LinkRouter = (props) => <Link {...props} component={RouterLink} />

    const Seperator = (props) => <Typography variant={isMobile ? 'subtitle1' : 'h5'} {...props}>/</Typography>

    return (
        <Grid container>
            <Grid item xs={12} lg={8} xl={6}>
                <div className={classes.titleWrapper}>
                    {
                        typeof badge !== 'undefined' ?
                            badge.show ?
                                <Badge
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    classes={{
                                        badge: clsx(badge.online ? classes.badgeOnline : classes.badgeOffline, classes.badge)
                                    }}
                                    badgeContent=" "
                                    className={classes.iconSpacing}
                                    overlap="circle"
                                >
                                    <SectionIcon className={classes.iconSizing} />
                                </Badge>
                                :
                                <SectionIcon className={clsx(classes.iconSpacing, classes.iconSizing)} />
                            :
                            <SectionIcon className={clsx(classes.iconSpacing, classes.iconSizing)} />
                    }
                    <div className={classes.breadcrumbList}>
                        {
                            breadcrumbs.map((bc, i) => {

                                return (
                                    i + 1 === breadcrumbs.length ?
                                        <React.Fragment key={i}>
                                            <Typography variant='h5' className={classes.breadcrumbsLast}>
                                                {bc.text}
                                            </Typography>
                                        </React.Fragment>
                                        :
                                        <React.Fragment key={i}>
                                            <Typography onClick={() => history.push(bc.link)} variant={isMobile ? 'subtitle1' : 'h5'} className={classes.breadcrumbs} >
                                                    {bc.text}
                                            </Typography>
                                            {
                                                !isMobile ?
                                                    <Seperator className={classes.seperator} />
                                                    :
                                                    i < breadcrumbs.length - 2 ?
                                                        <Seperator className={classes.seperator} />
                                                        :
                                                        <div style={{ flexBasis: '100%' }} />
                                            }
                                        </React.Fragment>
                                );
                            })

                        }
                    </div>
                </div>
            </Grid>
            {
                isMobile &&
                <Grid item xs={12}>
                    <Divider className={classes.divider} />
                </Grid>
            }
            <Grid item xs={12} lg={4} xl={6}>
                <div className={classes.buttons}>
                    {actionButtons}
                </div>
            </Grid>
            {
                !isMobile &&
                <Grid item xs={12}>
                    <Divider className={classes.divider} />
                </Grid>
            }
        </Grid>
    );

}

FingotiHeader.propTypes = {
    breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string.isRequired,
        link: PropTypes.string
    }))
}